module.exports = __webpack_public_path__ + "img/skythak-6.8bbf14c0.jpg";